import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Card, CardContent, Typography, Button, CardHeader, List, ListItem, ListItemIcon, ListItemText, CardMedia, CardActions } from '@mui/material';

interface Resource {
  _id: string;
  title: string;
  body: string;
  phoneNumber?: string | null;
  externalLink?: string | null;
  externalLinkText?: string | null;
  videoLink?: string | null;
  availability?: string | null;
}

interface ResourceCardProps {
  resource: Resource;
}

export const ResourceCard: React.FC<ResourceCardProps> = ({ resource }) => {
  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <CardHeader title={resource.title} />
      {resource.videoLink && (
        <CardMedia sx={{ height: 300 }}>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${resource.videoLink}`}
            title={resource.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </CardMedia>
      )}
      <CardContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {resource.body}
        </Typography>
        <List>
          {resource.phoneNumber && (
            <ListItem
              secondaryAction={
                <Button variant="outlined" component="a" href={`tel:${resource.phoneNumber}`}>
                  Call
                </Button>
              }
            >
              <ListItemIcon>
                <FontAwesomeIcon icon={faPhone} />
              </ListItemIcon>
              <ListItemText primary={resource.phoneNumber} />
            </ListItem>
          )}
          {resource.availability && (
            <ListItem>
              <ListItemIcon>
                <FontAwesomeIcon icon={faTriangleExclamation} />
              </ListItemIcon>
              <ListItemText primary={resource.availability} />
            </ListItem>
          )}
        </List>
      </CardContent>
      <CardActions>
        {resource.externalLink && (
          <Button component="a" href={resource.externalLink} target="_blank" rel="noopener noreferrer" fullWidth>
            {resource.externalLinkText || 'Learn More'}
          </Button>
        )}
      </CardActions>
    </Card>
  );
};
